import { ArticleDetailPage } from './pages/article-detail/ArticleDetail.page'
import { AudioDetailPage } from './pages/audio-detail/AudioDetail.page'
import { ContentRoot } from './pages/content-root/ContentRoot.page'
import { VideoDetailPage } from './pages/video-detail/VideoDetail.page'

import type { RouteObject } from 'react-router-dom'

const contentRoutes: RouteObject[] = [
  {
    path: 'content',
    element: <ContentRoot />,
    children: [
      {
        path: 'article/:id',
        element: <ArticleDetailPage />,
      },
      {
        path: 'video/:id',
        element: <VideoDetailPage />,
      },
      {
        path: 'audio/:id',
        element: <AudioDetailPage />,
      },
    ],
  },
]

export { contentRoutes }
